import React from "react";
import { useNavigate } from "react-router-dom";
import { Users, ExternalLink } from "lucide-react";
import { useCompleteStep } from "../hooks/useCompleteStep";

const CustomersStep: React.FC = () => {
  const navigate = useNavigate();
  const { complete, dashboardPath, isLastStep, onboarding, stepIndex } =
    useCompleteStep("customers");

  const handleComplete = () => {
    complete();
    if (isLastStep) {
      navigate(dashboardPath);
    }
  };

  if (onboarding.completedSteps[stepIndex]) {
    return (
      <div className="flex flex-col items-center justify-center py-12 text-center">
        <Users className="h-16 w-16 text-green-500 mb-4" />
        <h3 className="text-xl font-semibold text-gray-800">Customers Step Complete!</h3>
        <p className="text-gray-500 mt-2">You're all set to manage your customers.</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto text-center">
      <div className="rounded-xl border bg-white p-8 shadow-sm">
        <Users className="h-12 w-12 text-primary mx-auto mb-4" />
        <h3 className="text-lg font-semibold mb-2">Manage Your Customers</h3>
        <p className="text-gray-500 text-sm mb-6">
          Keep track of your customers to build loyalty and track purchase history.
        </p>

        <a
          href={`${dashboardPath}/customers`}
          target="_blank"
          rel="noopener noreferrer"
          className="form-btn w-full flex items-center justify-center gap-2 mb-4"
        >
          <span>Go to Customers</span>
          <ExternalLink className="h-4 w-4" />
        </a>

        <button
          onClick={handleComplete}
          className="w-full rounded bg-green-600 px-4 py-2 text-white font-medium hover:bg-green-700 transition-colors"
        >
          Complete Onboarding
        </button>
      </div>
    </div>
  );
};

export default CustomersStep;
